// test123
(123 && 0);
